import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const LocalizationGroupSchema_ = z.object({
  _id: z.string(),
  name: z.string(),
  description: z.string(),
  countries: z.array(z.string()),
  languages: z.array(z.string()),
});

export const LocalizationGroupSchema: z.ZodType<LocalizationGroupSchema> =
  LocalizationGroupSchema_;
export interface LocalizationGroupSchema
  extends z.infer<typeof LocalizationGroupSchema_> {}

export const getLocalizationGroups = {
  name: "getLocalizationGroups" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ localizationGroups: z.array(LocalizationGroupSchema) }),
};
